import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import * as R from 'ramda';
import { useDispatch } from 'react-redux';

import * as Loadings from '../../../../constants/loadings/backoffice/partners';
import { GenerateApiKey as GenerateApiKeyAction } from '../../../../actions/backoffice/partners';

export const GenerateApiKey = ({ partnerId, isLoading, selectedEtablissement }) => {
	const dispatch = useDispatch();
	const loadingState = isLoading || [];
	const isGenerating = loadingState.includes(Loadings.GENERATING_ETABLISSEMENT_API_KEY);
	const hasSelection = !R.isNil(selectedEtablissement);
	const [apiKeyPayload, setApiKeyPayload] = useState(undefined);

	useEffect(() => {
		const modal = $('#GeneratePartnerApiKey');
		const handleHidden = () => {
			setApiKeyPayload(undefined);
		};
		modal.on('hidden.bs.modal', handleHidden);
		return () => {
			modal.off('hidden.bs.modal', handleHidden);
		};
	}, []);

	const handlePrimaryAction = (event) => {
		event.preventDefault();
		if (apiKeyPayload) {
			$('#GeneratePartnerApiKey').modal('hide');
			return;
		}

		if (!hasSelection || isGenerating) {
			return;
		}

		dispatch(GenerateApiKeyAction(partnerId, selectedEtablissement.id))
			.then((response) => {
				setApiKeyPayload({
					clientId: selectedEtablissement.id,
					clientSecret: response?.newPassword
				});
			})
			.catch(() => {
				/* errors handled via toasts */
			});
	};

	return (
		<div className="modal fade px-0" id="GeneratePartnerApiKey" aria-labelledby="GeneratePartnerApiKeyLabel" aria-hidden="true">
			<div className="modal-dialog px-2 modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert alert-primary rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h5 className="sr-only visually-hidden">Générer Api Key</h5>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-primary text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="GeneratePartnerApiKeyLabel">Générer Api Key</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body scroll-default py-0">
						{apiKeyPayload ? (
							<div className="h6 lh-copy mb-3">
								<p className="mb-2">Voici les clés à communiquer au partenaire:</p>
								<div className="bg-light rounded p-2">
									<p className="mb-0">
										<span className="font-weight-bold">Etablissement:</span> {selectedEtablissement?.name || '-'}<br/>
                                        <span className="font-weight-bold">clientId:</span> {apiKeyPayload.clientId}<br/>
									    <span className="font-weight-bold">clientSecret:</span> {apiKeyPayload.clientSecret}
                                    </p>
								</div>
							</div>
						) : (
							<p className="h6 lh-copy mb-3">
								Si cet établissement possède déjà une API Key, la nouvelle clé va écraser l'ancienne. L'ancienne cessera de fonctionner immédiatement.
							</p>
						)}
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light mr-2" data-dismiss="modal">Annuler</button>
						<button type="button" className="btn btn-primary" disabled={(!hasSelection || isGenerating) && !apiKeyPayload} onClick={handlePrimaryAction}>
							{apiKeyPayload ? (
								"Fermer"
							) : isGenerating ? (
								<span className="d-inline-flex align-items-center">
									Générer
									<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
								</span>
							) : (
								"Générer"
							)}
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
